import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as marketplaceDemoReducer from "containers/MarketplaceDemo/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import { getUserID } from "containers/Login/reducer";
import * as viewReducer from "containers/View/reducer";
import Marketplace from "components/MarketplaceDemo/Marketplace";

class MarketplaceContainer extends React.PureComponent {
  componentDidMount() {
    const { fetchInitialBlueprints } = this.props;
    fetchInitialBlueprints();
  }

  render() {
    return <Marketplace {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateBlueprints: (blueprints) => dispatch(marketplaceDemoReducer.updateBlueprints(blueprints)),
  updateModels: (models) => dispatch(marketplaceDemoReducer.updateModels(models)),
  fetchBlueprints: () => dispatch(marketplaceDemoReducer.fetchBlueprints()),
  fetchModels: () => dispatch(marketplaceDemoReducer.fetchModels()),
  fetchData: () => dispatch(marketplaceDemoReducer.fetchData()),
  fetchConsulting: () => dispatch(marketplaceDemoReducer.fetchConsulting()),
  buyBlueprint: (id) => dispatch(marketplaceDemoReducer.buyBlueprint(id)),
  unbuyBlueprint: (id) => dispatch(marketplaceDemoReducer.unbuyBlueprint(id)),
  buyModel: (id) => dispatch(marketplaceDemoReducer.buyModel(id)),
  unbuyModel: (id) => dispatch(marketplaceDemoReducer.unbuyModel(id)),
  buyData: (id) => dispatch(marketplaceDemoReducer.buyData(id)),
  unbuyData: (id) => dispatch(marketplaceDemoReducer.unbuyData(id)),
  buyConsulting: (id, details) => dispatch(marketplaceDemoReducer.buyConsulting(id, details)),
  createConsulting: (consulting) => dispatch(marketplaceDemoReducer.createConsulting(consulting)),
  deleteConsulting: (id) => dispatch(marketplaceDemoReducer.deleteConsulting(id)),
  fetchInitialBlueprints: () => dispatch(blueprintReducer.fetchNextBlueprints()),
  getLinkedConsultants: (id) => dispatch(marketplaceDemoReducer.getLinkedConsultants(id))
});

const mapStateToProps = (state) => ({
  blueprints: marketplaceDemoReducer.getBlueprints(state),
  models: marketplaceDemoReducer.getModels(state),
  data: marketplaceDemoReducer.getData(state),
  consulting: marketplaceDemoReducer.getConsulting(state),
  allBPs: viewReducer.getBlueprints(state),
  allData: viewReducer.getDatasets(state),
  userId: getUserID(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(MarketplaceContainer);
